import injectSheet from 'react-jss';

import XAxis from './component';
import styles from './styles';

export default injectSheet(styles)(XAxis);
